import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainTabBasePathEnum } from '../../../enums/main-tabs';
import { MultipleResultsPageModule } from '../multiple-results/multiple-results.module';
import { ProfilePageModule } from '../profile/profile.module';
import { ShareContactInfoPageModule } from '../share-contact-info/share-contact-info.module';
import { StorePageRoutingModule } from '../store/store-routing.module';
import { AlertsPageModule } from './alerts/alerts.module';
import { FilterPageModule } from './filter/filter.module';
import { HelpPageModule } from './help/help.module';
import { HomePageModule } from './home/home.module';
import { PropertyPageModule } from './property/property.module';
import { SavePageModule } from './save/save.module';
import { ViewPageModule } from './view/view.module';

const routes: Routes = [
  {
    loadChildren: () => HomePageModule,
    path: ''
  },
  {
    loadChildren: () => HelpPageModule,
    path: 'help'
  },
  {
    loadChildren: () => FilterPageModule,
    path: 'filter'
  },
  {
    loadChildren: () => ViewPageModule,
    path: ':id/view'
  },
  {
    loadChildren: () => PropertyPageModule,
    path: ':id/view/property/:propertyId'
  },
  {
    loadChildren: () => AlertsPageModule,
    path: ':id/alerts'
  },
  {
    loadChildren: () => SavePageModule,
    path: 'save'
  },
  {
    loadChildren: () => ShareContactInfoPageModule,
    path: 'share-contact-info'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.WalkingFarm
    },
    loadChildren: () => ProfilePageModule,
    path: 'profile'
  },
  {
    loadChildren: () => MultipleResultsPageModule,
    path: 'multiple-results'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.WalkingFarm
    },
    loadChildren: () => StorePageRoutingModule,
    path: 'store'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class WalkingFarmRoutingModule {}
